module.exports = __webpack_public_path__ + "static/media/particles-in-japanese.982775b7.jpg";